export enum ReservationConfigType {
  DEFAULT = 'DEFAULT',
  SPECIAL_DATE = 'SPECIAL_DATE',
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/enums/reservation-config-type.enum.ts